import { Component, Input, OnInit } from '@angular/core';
import { map } from 'rxjs/operators';
import { SearchType } from 'src/app/library/enums/filters/search-type.enum';
import { FilterService } from 'src/app/library/services/filter/filter.service';
import { SearchApiService } from 'src/app/library/services/search/search-api.service';

@Component({
    selector: 'filter-sort',
    templateUrl: './filter-sort.component.html',
    styleUrls: ['./filter-sort.component.scss']
})
export class FilterSortComponent implements OnInit {
    @Input() endpoint: string;
    @Input() searchPlaceholder?: string;

    @Input() dialogOption: boolean = false;

    @Input() searchType?: SearchType;
    @Input() pageSize = 20;
    @Input() initialSearchText?: string;

    public loadingConfig: boolean;

    public isSimpleSearch: boolean;
    public isSingleSort: boolean;
    public isNotesAdvancedSearch: boolean;
    public isCaseHistoryAdvanced: boolean;

    public readonly searchTypeEnum = SearchType;

    private _page = 1;

    constructor(
        private searchApiService: SearchApiService,
        private filterService: FilterService
    ) {}

    async ngOnInit() {
        this.isSimpleSearch = this.searchType == this.searchTypeEnum.Simple;
        this.isSingleSort = this.searchType == this.searchTypeEnum.SingleFilter;
        this.isNotesAdvancedSearch =
            this.searchType == this.searchTypeEnum.NotesAdvanced;
        this.isCaseHistoryAdvanced =
            this.searchType == this.searchTypeEnum.CaseHistoryAdvanced;
        if (
            !this.filterService.filterConfig ||
            this.isCaseHistoryAdvanced ||
            this.filterService.filterConfig.endpoint !== this.endpoint
        ) {
            await this.reset();
        }
    }

    public async reset() {
        this.initConfig();
        this.filterService.data = null;
        this.filterService.totalResults = null;
    }

    private async initConfig() {
        //load data on init
        if (
            this.isSingleSort ||
            this.isNotesAdvancedSearch ||
            this.isCaseHistoryAdvanced
        ) {
            this.filterService.filterConfig = {
                endpoint: this.endpoint,
                searchPlaceholder: this.searchPlaceholder,
                page: this._page,
                pageSize: this.pageSize,
                searchText: this.initialSearchText
            };

            this.filterService.filterChangeEvent();
            return;
        }

        this.loadingConfig = true;

        const response = await this.searchApiService
            .Search(this.endpoint, '')
            .toPromise();
        if (response?.success) {
            this.filterService.filterConfig = {
                endpoint: this.endpoint,
                searchPlaceholder: this.searchPlaceholder,
                filters: response.filterWrapper.filters,
                sorts: response.filterWrapper.sorts.map(e => {
                    if (e.default) {
                        e.selected = true;
                        e.added = new Date();
                        e.direction = e.defaultOrder;
                    }
                    return e;
                }),
                page: this._page,
                pageSize: this.pageSize,
                searchText: this.initialSearchText
            };

            this.loadingConfig = false;
        }

        if (this.initialSearchText) {
            this.filterService.searchText = this.initialSearchText;
            this.initialSearchText = '';
        }
    }

    get selectedFilters$() {
        return this.filterService.filterConfig$.pipe(
            map(e => {
                if (e) {
                    return e.filters
                        ?.filter(x => x.selected)
                        .sort((a, b) => (a.added > b.added ? 1 : -1));
                }
            })
        );
    }

    get selectedSorts$() {
        return this.filterService.filterConfig$.pipe(
            map(e => {
                if (e) {
                    return e.sorts
                        ?.filter(x => x.selected)
                        .sort((a, b) => (a.added > b.added ? 1 : -1));
                }
            })
        );
    }
}
